module.exports = __webpack_public_path__ + "img/PTGPR.84cb156b.svg";